import getCurrentUser from "@/router/middleware/getCurrentUser";
import SspMobileChildrens from "@/router/mobile/children/ssp-mobile-childrens";

const OidcCallback = () =>
  import(/* webpackChunkName: "OidcCallback" */ "@/components/OidcCallback.vue");
const SspMobile = () => import(/* webpackChunkName: "Ssp" */ "@/components/SspMobile.vue");

export const mobileRouter = [
  {
    path: "/",
    children: SspMobileChildrens,
    component: SspMobile,
    beforeEnter: getCurrentUser(),
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];
